import { FC, memo, useMemo } from 'react';

import BarChartHorizontal from './BarChartHorizontal';
import BarChartVertical from './BarChartVertical';

import { getProcessedMeta } from '../../../utilities/common/chart';
import {
  BarChartMetaData,
  WidgetDefinition,
} from '../../../shared/types/widget';
import './index.css';

type BarChartProps = {
  definition: WidgetDefinition;
  content: BarChartMetaData;
};

// Outside the BarChart component
const ChartContent: FC<{
  isHorizontal: boolean;
  processedMeta: ReturnType<typeof getProcessedMeta>;
  title: string;
}> = ({ isHorizontal, processedMeta, title }) => {
  const id = title.split(' ').join('_');

  return isHorizontal ? (
    <BarChartHorizontal
      data={processedMeta.data}
      legend={processedMeta.meta.legend}
      meta={processedMeta.meta}
    />
  ) : (
    <BarChartVertical
      id={id}
      data={processedMeta.data}
      legend={processedMeta.meta.legend}
      backgroundColors={processedMeta.meta.backgroundColors}
      labels={processedMeta.data.datasets.length > 1}
    />
  );
};

const BarChart: React.FC<BarChartProps> = ({ definition, content }) => {
  const { title } = definition;
  const { meta } = content || {};
  const isHorizontal = meta?.indexAxis === 'y';

  const processedMeta = useMemo(
    () => getProcessedMeta({ meta: content }),
    [meta],
  );

  return (
    <ChartContent
      isHorizontal={isHorizontal}
      processedMeta={processedMeta}
      title={title}
    />
  );
};

export default memo(BarChart);
